export enum TagVariant {
  FILLED = 'filled',
  OUTLINED = 'outlined',
  NONE = 'none'
}

export enum TagColorMode {
  COLORFUL = 'colorful',
  UNIFORM = 'uniform'
}

export enum TagType {
  TRAINER = 'trainer',
  PARTICIPANT = 'participant',
  COORDINATOR = 'coordinator',
  DEMO = 'demo',
  IN_SESSION = 'in session',
  PLANNED = 'planned',
  ENDED = 'ended',
  FINISHED = 'finished'
}

export enum TagColor {
  LIGHT_GREEN = '#8BA90F',
  DARK_GREEN = '#3D9E41',
  LIGHT_BLUE = '#0EABE6',
  DARK_BLUE = '#3D7ED1',
  YELLOW = '#E6DC3C',
  ORANGE = '#D17D47',
  RED = '#E6244F',
  BROWN = '#947065',
  PINK = '#ED6BC8',
  VIOLET = '#6A1B9A',
  DARK_GREY = '#424242',
  TEAL = '#3D9A9E'
}

export const DEFAULT_TAG_VARIANT = TagVariant.OUTLINED;
export const DEFAULT_TAG_COLOR_MODE = TagColorMode.UNIFORM;
export const DEFAULT_UNIFORM_COLOR = '#ffffff';
export const DEFAULT_BORDER_SIZE = 2;
export const DEFAULT_FONT_SIZE = 11;
export const DEFAULT_BORDER_RADIUS = 12;
export const DEFAULT_LETTER_SPACING = 0.4;
export const DEFAULT_PADDING = '2px 8px';

export const TAG_COLORS = [
  TagColor.LIGHT_GREEN,
  TagColor.DARK_GREEN,
  TagColor.LIGHT_BLUE,
  TagColor.DARK_BLUE,
  TagColor.YELLOW,
  TagColor.ORANGE,
  TagColor.RED,
  TagColor.BROWN,
  TagColor.PINK,
  TagColor.VIOLET,
  TagColor.DARK_GREY,
  TagColor.TEAL
] as const;

export const PREDEFINED_TAG_COLORS: Record<string, TagColor> = {
  [TagType.TRAINER]: TagColor.LIGHT_GREEN,
  [TagType.PARTICIPANT]: TagColor.DARK_GREEN,
  [TagType.COORDINATOR]: TagColor.LIGHT_BLUE,
  [TagType.DEMO]: TagColor.DARK_BLUE,
  Demo: TagColor.DARK_BLUE, // Backend uses "Demo"
  [TagType.IN_SESSION]: TagColor.YELLOW,
  'In Session': TagColor.YELLOW, // Backend uses "In Session"
  [TagType.PLANNED]: TagColor.ORANGE,
  Planned: TagColor.ORANGE, // Backend uses "Planned"
  [TagType.ENDED]: TagColor.RED,
  Ended: TagColor.RED, // Backend uses "Ended"
  [TagType.FINISHED]: TagColor.BROWN,
  Finished: TagColor.BROWN // Backend uses "Finished"
};

export const TAG_VARIANT_OPTIONS = [
  { value: TagVariant.FILLED, label: 'Filled' },
  { value: TagVariant.OUTLINED, label: 'Outlined' },
  { value: TagVariant.NONE, label: 'None (hide in app)' }
];

export const TAG_COLOR_MODE_OPTIONS = [
  { value: TagColorMode.COLORFUL, label: 'Colorful (each tag different color)' },
  { value: TagColorMode.UNIFORM, label: 'Uniform (all tags same color)' }
];

export const BORDER_SIZE_RANGE = {
  MIN: 1,
  MAX: 10,
  DEFAULT: DEFAULT_BORDER_SIZE
};

export const FONT_SIZE_RANGE = {
  MIN: 8,
  MAX: 24,
  DEFAULT: DEFAULT_FONT_SIZE
};

export const TAG_STYLING_DEFAULTS = {
  uniformColor: DEFAULT_UNIFORM_COLOR,
  borderSize: DEFAULT_BORDER_SIZE,
  fontSize: DEFAULT_FONT_SIZE,
  borderRadius: DEFAULT_BORDER_RADIUS,
  letterSpacing: DEFAULT_LETTER_SPACING,
  padding: DEFAULT_PADDING
} as const;
